/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roomannouncementstonight2Inputs */

const en_roomannouncementstonight2 = /** @type {(inputs: Roomannouncementstonight2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent tonight`)
};

const de_roomannouncementstonight2 = /** @type {(inputs: Roomannouncementstonight2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute gesendet`)
};

/**
* | output |
* | --- |
* | "Sent tonight" |
*
* @param {Roomannouncementstonight2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementstonight2 = /** @type {((inputs?: Roomannouncementstonight2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementstonight2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementstonight2(inputs)
	return de_roomannouncementstonight2(inputs)
});
export { roomannouncementstonight2 as "roomAnnouncementsTonight" }